import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import axios from 'axios';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import CKEditor from 'ckeditor4-react';

	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {
			insurance_name:'',
			description:'',
			amount:'',
			period:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedPlanOption: '',
			selectedvalue:'active',
			selectedPlanvalue:'',
			planLists:'',
			discount_percentage:'',
			visit_limit:'',
			discount_validity:'',
			discount_type:'',
			image: '',
			image_name:'',
			image_preview:''
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onEditorChange = this.onEditorChange.bind( this );
    }

	onEditorChange( evt ) {
    	// console.log(evt.editor.getData(), 'CKE')
    	var callfunc = this;
    	setTimeout(function () {
		callfunc.setState( {
            description: evt.editor.getData()
        } );
		}, 1000);
     
    }
	componentDidMount() {
	
	console.log("component did mount")
	}
	  
// 	handleChange = selectedOption => {
//         this.setState({selectedOption})
//         this.setState({  selectedvalue : selectedOption.value});
//    };

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}else if(r == 'ins_cate'){			
			this.setState({selectedPlanOption:selOption})
			this.setState({  selectedPlanvalue : selOption.value});
		}
		console.log(selOption.value, 'sdfg')
	};

   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });

  }
 
  
  handleSubmit = () => {
	if(this.validateForm()){
	this.setState({Loading:true});
	const formdata = this.state;
	var qs = require('qs');
	var status, cate = '';

	const config = {
		headers: {
			'content-type': 'multipart/form-data'
		}
	}

	if(formdata.selectedvalue === ''){
	status =formdata.selectedOption.value;
	}else{
	status = formdata.selectedvalue;
	}

	if(formdata.selectedPlanvalue === '' && formdata.selectedPlanvalue!== 0){
		cate =formdata.selectedPlanOption.value;
	}else{
		cate = formdata.selectedPlanvalue;
	}

	var postObject ={
		admin_id: localStorage.getItem('admin_id'),
		insurance_name : formdata.insurance_name,
		description:formdata.description,
		amount: formdata.amount,
		period: formdata.period,
		discount_percentage: formdata.discount_percentage,
		visit_limit: formdata.visit_limit,
		discount_validity: formdata.discount_validity,
		discount_type: formdata.discount_type,
		image: formdata.image,
		status: status,
		cate_id:cate
	}


	let formData = new FormData();

	for(let k in postObject) {
		formData.append(k, postObject[k]);
	}
						


	axios.post(apiUrl+"insurance/add",formData,config).then(res => {
		if(res.data.status === "success"){
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						setTimeout(
						function() {
							$('.success_message').html(this.props.history.push('/Insurance'));
						}
						.bind(this),
						3000
						);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				
				setTimeout(
				function() {
					$('.success_message').html('');
				}
				.bind(this),
				3000
				);
				this.setState({Loading:false});
			}
		});
		
	}
  }

  validateForm() {
	const {insurance_name,description,amount, period, selectedPlanOption, image} = this.state;

	let errors = {};
	  let formIsValid = true;

	  if(!insurance_name){
		formIsValid = false;
		$('.errorinsurance_name').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.errorinsurance_name').html('');
	}

	if(!description){
		formIsValid = false;
		$('.errordescription').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.errordescription').html('');
	}

	// if(!image){
	// 	formIsValid = false;
	// 	$('.errorimage').html('<span class="errorspan">Please choose image</span>');
	// }else{
		
	// 	$('.errorimage').html('');
	// }
	
	if(!amount){
		formIsValid = false;
		$('.erroramount').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.erroramount').html('');
	}

	if(!period){
		formIsValid = false;
		$('.errorperiod').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.errorperiod').html('');
	}

	if(!selectedPlanOption){
		formIsValid = false;
		$('.errorplan').html('<span class="errorspan">Please fill the field</span>');
	}else{
		
		$('.errorplan').html('');
	}
		
	this.setState({
		errors: errors
	});
	return formIsValid;
}


onChangeHandler=event=>{
	let reader = new FileReader();
	 const file = event.target.files[0];
	 reader.onloadend = () => {		
		 
	   this.setState({
		 image_name: file.name,
		 image_preview: reader.result,
		 image: file
	   });
	 };
	 reader.readAsDataURL(file);
	 $('.errorimage').html('');
   }


  render() {
	const {selectedOption,selectedPlanOption} = this.state;
	if(this.state.discount_type == 'flat')
	{
		$('.discount_amount').html('Prescription Discount ($):')
		
	}else{
		$('.discount_amount').html('Prescription Discount (%):')
	}	
	
    return (
      <div className="wrapper"> 
 
	  <Header />
      <MenuSidebar currentpage="Insurance" />  

	<div id="location-error"></div>
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a className="cursor-pointer btn-arrow" href="/Insurance">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
				</a>
			</div>
			<div className="title">
				<h4>Add Membership</h4>				
			</div>
			 <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
			
			   <div className="form-group">
					<label>Name<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="insurance_name" onChange={this.handleInputChange} className="form-control" value={this.state.insurance_name}/>
					<div className="errorinsurance_name"></div>
				</div>
				<div className="form-group">					
					<label>Category<span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select 
						   value={selectedPlanOption?selectedPlanOption:""}
                            options={lang.common.insurance_plan_option} 
                            onChange={this.handleChange.bind(this, 'ins_cate')}
                            />
							<div className="errorplan"></div>
	           </div> 
				<div className="form-group">
					<label>Amount ($)<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="number" name="amount" onChange={this.handleInputChange} className="form-control" value={this.state.amount}/>
					<div className="erroramount"></div>
				</div>
			
				<div className="form-group">
					<label>Visit Limit <span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="number" name="visit_limit" onChange={this.handleInputChange} className="form-control" value={this.state.visit_limit}/>
					<div className="errorvisit_limit"></div>
				</div>
				<div className="form-group">
					<label>Period<span class="required" style={{ color: "red" }} > * </span> : </label> <br></br>
				    <input type="radio" name="period" value="Month" onChange={this.handleInputChange} className="form-control" />
					<label for="Month">Monthly</label>
				    <input type="radio" name="period" value="Year" onChange={this.handleInputChange} className="form-control"   />
					<label for="Year">Yearly</label>
					 <input type="radio" name="period" value="Day" onChange={this.handleInputChange} className="form-control"   />
					<label for="Year">Daily</label>
					 <input type="radio" name="period" value="onetime" onChange={this.handleInputChange} className="form-control"   />
					<label for="One Time">One Time</label>
					<div className="errorperiod"></div>
				</div>

				<div className="form-group">
			    <label>Image:</label>
				<div className="choose-file">
                
                   <span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
                </div>
                <div className="errorimage"></div>
                </div>
				
			</div>
                  
			<div className="form-right">
			<div className="form-group">					
					<label>Description<span class="required" style={{ color: "red" }} > * </span> :</label>
						{/* <textarea type="text" name='description' onChange={this.handleInputChange} className='form-control' value={this.state.description} /> */}
						<CKEditor
					data={this.state.description}
					//data={templatecontent}
					onChange={this.onEditorChange}
					type="classic"
					/>
					<div className="errordescription"></div>
				</div>

				<div className="form-group">
					<label className='discount_amount'>Prescription  Discount (%)<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="number" name="discount_percentage" onChange={this.handleInputChange} className="form-control" value={this.state.discount_percentage}/>
					<div className="errordiscount_percentage"></div>
				</div>
				<div className="form-group">
					<label>Discount Validity (Month)<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="number" name="discount_validity" onChange={this.handleInputChange} className="form-control" value={this.state.discount_validity}/>
					<div className="errordiscount_validity"></div>
				</div>

				<div className="form-group">
						<label>Discount type: </label>
						<br></br>
						<input onChange={this.handleInputChange} type="radio" name="discount_type" checked={this.state.discount_type=='flat'?'chekced':''} value="flat"/>
						<label>Flat Amount</label>
							<input onChange={this.handleInputChange} type="radio"  name="discount_type" checked={this.state.discount_type=='percentage'?'chekced':''} value="percentage" />
						<label>Percentage</label>
					</div> 
				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select 
						   name="status"
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option} 
							isSearchable = {false}
							onChange={this.handleChange.bind(this, 'status')}
                            />
	           </div> 
			  
             

			</div>	
			</div>		
			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>Adding</span>:<span>Submit</span>
                                        }
			   </button>
			 
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Add));